import type { ClassConstructor } from '~/shared/types/generics'
import { isArray, isUnknownObject } from '~/shared/utils/guards'
import type BaseModel from './base'

export function convertToModel<T extends BaseModel, D = null>(
  data: unknown,
  modelCtor: ClassConstructor<T>,
  defaultValue: D = null as D
): T | D {
  return isUnknownObject(data) ? new modelCtor(data) : defaultValue
}

export function convertToArrayModels<T extends BaseModel>(data: unknown, modelCtor: ClassConstructor<T>): T[] {
  if (isArray(data) && data.length) {
    return data.map(item => new modelCtor(item))
  }

  return []
}
